import api from '@api/apiServices';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { emailDraftQueryOptions } from '@utils/queryOptions';
import EditEmailDraftTemplate from '@Views/Emails/drafts/edit-draft-template';
import { t } from 'i18next';

export const Route = createFileRoute('/emails/drafts/$draftId/edit')({
    component: EditEmailDraftTemplate,
    loader: opts =>
        opts.context.queryClient.ensureQueryData(
            emailDraftQueryOptions(opts.params.draftId),
        ),
    beforeLoad: data => {
        if (data.params.draftId === 'new') {
            return data.context.queryClient.fetchQuery({
                queryKey: ['newEmailDraft', Math.random()],
                queryFn: () =>
                    api.emails.drafts
                        .postForm({ subject: t('Untitled Email') })
                        .then(res => redirect({ to: `../../${res.id}/edit` })),
            });
        }
    },
});
